import React from "react"

// Store name primary, domain secondary — the canonical "who is this merchant"
// display wherever a shop shows up (transactions, subscriptions, activity,
// top lists, customers table). Falls back to the domain alone when no name
// is known yet (unmatched/legacy rows).
export function MerchantLabel({
  name,
  shop,
  primaryClassName = "truncate text-sm font-medium text-gray-800 dark:text-gray-200",
  secondaryClassName = "truncate text-xs text-gray-400 dark:text-gray-500",
}) {
  const label = name || shop || "—"
  return (
    <>
      <p className={primaryClassName}>{label}</p>
      {name && shop && <p className={secondaryClassName}>{shop}</p>}
    </>
  )
}

// Same label, wrapped in a link to the customer detail page when a
// merchant_id is known. Rows that couldn't be resolved to a merchant (no
// sync match yet) render as plain, non-interactive text.
export function MerchantCell({ name, shop, merchantId, detailBasePath, primaryClassName, secondaryClassName }) {
  const body = (
    <MerchantLabel name={name} shop={shop} primaryClassName={primaryClassName} secondaryClassName={secondaryClassName} />
  )
  if (merchantId && detailBasePath) {
    return (
      <a href={`${detailBasePath}/${merchantId}`} className="block min-w-0 hover:opacity-80">
        {body}
      </a>
    )
  }
  return <div className="min-w-0">{body}</div>
}
